export enum RiskFields {
  ID = 'id',
  QUERY = 'query',
  TITLE = 'title',
  STATUS = 'status',
  EDITOR = 'editor',
  DOMAIN = 'domain',
  TICKETS = 'tickets',
  SOURCES = 'sources',
  ENABLED = 'enabled',
  STANDARDS = 'standards',
  SOURCE_ID = 'source_id',
  USER_NAME = 'user_name',
  BIG_RISK = 'is_big_risk',
  CREATED_BY = 'created_by',
  RISK_SCORE = 'risk_score',
  IS_DELETED = 'is_deleted',
  REMEDIATION = 'remediation',
  POLICY_TYPE = 'policy_type',
  CATEGORY_ID = 'category_id',
  DESCRIPTION = 'description',
  TICKET_DATA = 'ticket_data',
  SECONDARY_ID = 'secondary_id',
  PRODUCT_NAME = 'product_name',
  FILTER_STEPS = 'filter_steps',
  CREATED_DATE = 'created_date',
  SNOOZE_UNTIL = 'snooze_until',
  APPLICATIONS = 'applications',
  UPDATED_DATE = 'updated_date',
  INSTANCE_NAME = 'instance_name',
  IS_POLICY_NEW = 'is_new_policy',
  RESOLVED_DATE = 'resolved_date',
  RECORDS_COUNT = 'records_count',
  SECONDARY_KEY = 'secondary_key',
  APPLICATION_ID = 'application_id',
  RECIPIENT_NAME = 'recipient_name',
  THREAT_VECTORS = 'threat_vectors',
  ATTACK_PATH_ID = 'attack_path_id',
  FILTER_AS_DICT = 'filter_as_dict',
  SEARCH_AS_DICT = 'search_as_dict',
  ASSIGNMENT_DATA = 'assignment_data',
  APPLICATION_NAME = 'application_name',
  POLICY_IDENTIFIER = 'policy_identifier',
  POLICY_FILTER_TYPE = 'policy_filter_type',
  IS_INFO_COLLECTION = 'is_info_collection',
  REMEDIATION_EFFECT = 'remediation_effect',
  LAST_CALCULATED_DATE = 'last_calculated_date',
  IS_POLICY_ITEMS_DATA = 'is_policy_items_data',
  IS_NEW_RECORDS_FOUND = 'is_new_records_found',
  MESSAGE_TEMPLATE_PARAMETERS = 'message_template_parameters',
}
